.Skeleton {
  background-color: var(--neutral-4);
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.ButtonSkeleton {
  border-radius: 19px;
  height: 38px;
  width: 100px;
  flex-shrink: 0;

  &.size-sm {
    height: 28px;
    width: 70px;
  }
}

.CheckboxSkeletonWrapper {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  .CheckboxSkeleton {
    border-radius: 50%;
    height: 15px;
    width: 15px;
  }
}

.ImageSkeleton {
  height: 30px;
  aspect-ratio: 1;
  border-radius: var(--radius-xs);
}

.SwitchSkeleton {
  width: 30px;
  aspect-ratio: 2 / 1;
  border-radius: 9999px;
}

.TextSkeleton {
  display: inline-block;
  border-radius: var(--radius-xs);
  height: 18px;
  width: 100%;
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
